import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {Usuario} from '../../../models/usuario.interface';

@Component({
  selector: 'app-switches',
  templateUrl: './switches.component.html',
  styleUrls: ['./switches.component.scss']
})
export class SwitchesComponent implements AfterViewInit {

  @Input() options: SwitchesOptions[] = [];

  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  currentIdSelected = '';

  tema = ``;
constructor() {
  const usr: Usuario = JSON.parse(window.localStorage.getItem('usuario'));
  this.tema = usr.temaModelo;
}


  ngAfterViewInit(): void {
    this.selectOption(this.options[0]);
  }


  selectOption( option: SwitchesOptions ) {
    this.currentIdSelected = option.id;

    this.itemSelected.emit( option.id );
  }

}
export interface SwitchesOptions extends ISelect {
  icon?: string;
}

export interface ISelect {
  id: string;
  label: string;
  disabled?: boolean;
}
